import { render } from "./Passengers.vue?vue&type=template&id=7fd29fea"
import script from "./Passengers.vue?vue&type=script&lang=js"
export * from "./Passengers.vue?vue&type=script&lang=js"
script.render = render

export default script